import React, { useCallback, useContext } from 'react';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import type { Container, Engine } from 'tsparticles-engine';
import { ThemeContext } from '../../Context/ThemeContext';

function ParticlesJS() {
	const { currentTheme } = useContext(ThemeContext);
	const particleColor = currentTheme === 'dark' ? '#ffffff' : '#000000';
	const pixelSize = currentTheme === 'dark' ? { max: 1, min: 1.5 } : { max: 1, min: 1.5 };

	const particlesInit = useCallback(async (engine: Engine) => {
		await loadFull(engine);
	}, []);

	const particlesLoaded = useCallback(async (container: Container | undefined) => {
		await console.log(container);
	}, []);

	return (
		<>
			<Particles
				id="tsparticles"
				init={particlesInit}
				loaded={particlesLoaded}
				options={{
					background: {
						color: {
							value: 'transparent',
						},
					},
					fpsLimit: 120,
					interactivity: {
						events: {
							onClick: {
								enable: true,
								mode: 'push',
							},
							onHover: {
								enable: true,
								mode: 'repulse',
							},
							resize: true,
						},
						modes: {
							push: {
								quantity: 2,
							},
							repulse: {
								distance: 100,
								duration: 1,
							},
						},
					},
					particles: {
						color: {
							value: `${particleColor}`,
						},

						collisions: {
							enable: true,
						},
						move: {
							enable: true,
							outModes: {
								default: 'bounce',
							},
							random: false,
							speed: 0.5,
							straight: false,
						},
						number: {
							density: {
								enable: true,
								area: 800,
							},
							value: 80,
						},
						opacity: {
							value: 0.5,
						},
						shape: {
							type: 'circle',
						},
						size: {
							value: { min: pixelSize.min, max: pixelSize.max },
						},
					},
					detectRetina: true,
				}}
			/>
		</>
	);
}

export default ParticlesJS;
